import {Component, inject, input, model, OnDestroy, OnInit, signal, ViewChild} from '@angular/core';
import {FormsModule, NgForm} from "@angular/forms";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {ActivatedRoute, Router} from "@angular/router";
import {FeatherModule} from "angular-feather";
import {notImplementedYet, scrollToInvalidElement} from "../../../../app.constants";
import {
  RegisterMethod,
  RightSearchResult,
  SignType,
  Source,
  SrmRegisterRequest
} from "../../../../../generated-model/model";
import {RegisterFormsComponent} from "../register-forms/register-forms.component";
import {ToastService} from "../../../../shared/commons/toast/toast-service";
import {DocumentSignComponent, DocumentSignModel} from "../register-forms/document-sign/document-sign.component";
import {
  RegisterFormViolationComponent
} from "../register-forms/validate-register-type-panel/register-form-violation.component";
import {SrmRegisterService} from "../../../../service/srm-register.service";
import {filter} from "rxjs/operators";
import {ConfirmDialogService} from "../../../../shared/commons/dialog/confirm-dialog/confirm-dialog.service";
import {SuccessDialogService} from "../../../../shared/commons/dialog/success-dialog/success-dialog.service";
import {
  ProgressionDialogService
} from "../../../../shared/commons/dialog/progression-dialog/progression-dialog.service";
import {RegistrationUtils} from "../../../../shared/commons/utils/registration-utils";
import {HttpErrorResponse} from "@angular/common/http";
import {DangerDialogService} from "../../../../shared/commons/dialog/danger-dialog/danger-dialog.service";
import {AlertDialogService} from "../../../../shared/commons/dialog/alert-dialog/alert-dialog.service";

@Component({
  selector: 'app-register-proxy',
  standalone: true,
  imports: [
    FormsModule,
    SharedCommonModule,
    RegisterFormsComponent,
    FeatherModule,
    DocumentSignComponent,
    RegisterFormViolationComponent
  ],
  templateUrl: './register-proxy.component.html',
  styleUrl: './register-proxy.component.scss',
  animations: []
})
export class RegisterProxyComponent implements OnInit, OnDestroy {
  protected readonly notImplementedYet = notImplementedYet;
  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  @ViewChild("searchForm", {read: NgForm, static: true}) searchForm: NgForm;
  formId = signal('register-by-thaid-form');
  formValid = signal<DocumentSignModel>(undefined);
  srmRegisterService = inject(SrmRegisterService);
  data = model.required<RightSearchResult>();
  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);
  toastService = inject(ToastService);
  //note i don't know why set source to 'NHSO' here it don't work
  source = model<Source>();
  request = signal<SrmRegisterRequest>(undefined);
  registerMethod = input.required<RegisterMethod>();
  showDocumentSignPanel = signal<boolean>(true);

  private confirmDialogService = inject(ConfirmDialogService);
  private successDialogService = inject(SuccessDialogService);
  private progressionDialogService: ProgressionDialogService = inject(ProgressionDialogService);
  private dangerDialogService = inject(DangerDialogService);
  private alertDialogService = inject(AlertDialogService);

  constructor() {
  }

  ngOnInit(): void {
    this.request.set({});
    this.request().registrantType = 'SELF';
    this.request().registerMethod = this.registerMethod();
  }

  submitForm() {
    this.confirmDialogService.open({content: 'ยืนยันการลงทะเบียน'})
      .pipe(filter(e => !!e))
      .subscribe({
        next: e => {
          this.progressionDialogService.open({content: "กำลังบันทึกข้อมูล..."});
          this.srmRegisterService.submitForm(this.request())
            .subscribe({
              next: e => {
                this.successDialogService.open('ลงทะเบียนเรียบร้อยแล้ว')
                this.srmRegisterService.downloadSignedFile(e);
                this.onSaveSuccess();
              },
              error: err => {
                console.log('submit form error: ', err);
                this.progressionDialogService.close();
                if (err instanceof HttpErrorResponse) {
                  if (err.status == 409) {
                    this.alertDialogService.open({
                      content: `<div class="text-center fw-semibold text-primary">${err.error?.message || 'รายการนี้ได้รับการลงทะเบียนโดยผู้ใช้ท่านอื่นแล้ว'}</div>`,
                      isInnerHTML: true
                    });
                    this.onSaveSuccess();
                  }
                } else {
                  this.dangerDialogService.open().subscribe();
                }
                throw err;
              },
              complete: () => {
                this.progressionDialogService.close();
              }
            });
        }
      });
  }

  validForm(sign: SignType) {
    this.srmRegisterService.validateForm(this.form, sign, this.request())
      .subscribe({
        next: e => {
          this.formValid.set(e);
        }, error: e => {
          console.log('invalid form...');
          this.toastService.showWarning("กรุณากรอกข้อมูลให้ครบถ้วน");
          try {
            scrollToInvalidElement(this.formId());
          } catch (e) {
            //do nothing.
          }
        }
      });
  }

  onSaveSuccess() {
    this.data.set(undefined);
    this.router.navigate(['../'], {relativeTo: this.activatedRoute});
  }

  showRegisterPanel(): boolean {
    return RegistrationUtils.showRegisterPanel(this.request().personalData, this.request().personalFund);
  }

  onShowDocumentSignPanelChange(showFlag: boolean) {
    this.showDocumentSignPanel.set(showFlag);
  }

  ngOnDestroy(): void {
  }
}
